export enum ErrorCodeType {
  GroundOnlyProduct = 'ground_only_product',
  PoBoxAddress = 'po_box_shipping_error',
  PoBoxSignature = 'po_box_signature_error',
  PoBoxCanadaRestriction = 'po_box_canada_restriction_error',
  NoShippingEstimate = 'no_shipping_methods',
  ShippingZipCode = 'shipping_zip_code_error',
  InvalidCreditCard = 'invalid_credit_card',
  CouponCodeError = 'coupon_error',
  GiftCardError = 'gift_cart_error',
  EmptyPaymentMethods = 'empty_payment_methods',
  ToManyRequests = 'to_many_requests',
}
